<script setup>
import LoginUserForm from "@/components/login-user/LoginUserForm.vue";

const route = useRoute();
const router = useRouter();

const loading = ref();

const load = () => {
  loading.value = true;
  setTimeout(() => {
    loading.value = false;
  }, 3000);
};

definePage({
  meta: {
    layout: "default",
  },
});
const pageTitle = "Login User";

const pageMethod = "Update";

const breadCrumbs = [
  {
    title: "Dashboard",
    to: "/admin/dashboard",
  },
  {
    title: "System",
    to: null,
  },
  {
    title: pageTitle,
    to: "/admin/login-user",
  },
  {
    title: pageMethod,
    to: null,
  },
];
</script>

<template>
  <VBreadcrumbs :items="breadCrumbs" class="px-0 pt-0 pb-5" />
  <LoginUserForm
    v-model:pageMethod="pageMethod"
    v-model:pageTitle="pageTitle"
  />
</template>
